<template>
    <div class="graybox " style="width: 100%;">
        <table class="table table-hover roa-table requirement_table">
           <thead>
              <tr>
                 <th>Name of the Document</th>
                 <th>Action</th>
                 <th>Status</th>
                 <th style="width: 200px; position: relative;">Upload
                 </th>
              </tr>
           </thead>
           <tbody class="p_list" >
              <tr v-for="(doc,index) in subscription" :key="index" >
                 <td>{{doc.label}}</td>
                 <td>
                    <!-- <a href="javascript://" >Download PDF</a> -->
                    <b-button v-b-modal.download_file_confirmation @click="doc_id=doc.id">Download PDF</b-button>
                 </td>
                 <td>{{doc.status | capitalize}}</td>
                 <td>
                  <div v-if="doc.doc_url==null" class="tbl-file-upload">
                      <b-button v-b-modal.upload_file_confirmation @click="doc_id=doc.id">
                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 29 29"><rect x="0.13" y="0.13" width="28.74" height="28.74" rx="14.37" class="cls-3"></rect><polyline points="10.04 13.47 14.5 9.01 18.96 13.47" class="cls-4"></polyline><line x1="14.5" y1="19.99" x2="14.5" y2="9.01" class="cls-4"></line></svg>
                      </b-button>
                    </div>
                    <div v-else>
                        Uploaded
                    </div>
                 </td>
              </tr>
           </tbody>
        </table>
        <b-modal id="upload_file_confirmation" centered  >
          <div class="uplod_popup">
            <h4>Name of the Form</h4>
            <br>
                <div class="tbl-file-upload">
                  <input type="file" ref="doc"  @change="getFile"   hidden />
                  <label for="actual-btn" @click="$refs.doc.click()">
                    Choose File
                  </label>
                  <br>
                  <span class="text-danger">{{file_error}}</span>
                </div>
                <p style="margin-top: 10px;color: #000;font-size: 14px;">Please ensure that you have added your Digital Signature to the form <br>before uploading</p>
          </div>
        </b-modal>

        <b-modal id="download_file_confirmation" centered  >
          <div class="uplod_popup">
            <!-- <h4>Name of the Form</h4> -->
            <p style="margin-top: 10px;color: #000;font-size: 16px;line-height: 28px;">Please download and add your digital signature to the form before uploading it onto the portal to continue further processing.</p>
            <br>
                <a href="javascript://" @click="download_pdf()" class="gobtn" style="margin-bottom: 10px;float: left;">Download</a>
                
          </div>
        </b-modal>





        <b-modal id="preview_model" centered  >
            <div class="required_documents">
                <div class="preview_model">
                    <form>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-heading">
                          <h4>FORM MBP – 1 </h4>
                          <p><b>Notice of interest by director </b></p>
                          <p>[Pursuant to section 184 (1) and rule 9(1)] </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-to">
                          <p>To&nbsp;</p>
                          <p>The Board of Directors  </p>
                          <table contenteditable="false" style="width: 30%;">
                             <tbody>
                                <tr>
                                   <td style="padding: 5px 10px 5px 0px;"> The Republic of accounting </td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content">
                          <p><b>Dear Sir(s)/Madam(s)  </b></p>
                          <p>I, <span role="textbox" contenteditable="false" class="input"><b>Deepak Kumar</b></span>, son/daughter of  <span role="textbox" contenteditable="false" class="input"><b>Sanjay Shiva</b></span>,
                             resident of <span role="textbox" contenteditable="false" class="input"><b>3rd Floor, Brigade Champak, Union Street</b></span>, being a director in the company hereby give notice of my interest or concern in the following company or companies, bodies corporate, firms or other association of individuals:-  
                          </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-table">
                          <table contenteditable="false" class="table table-border form-table">
                             <thead>
                                <tr>
                                   <th width="8%" style="width: 30px;">Sl No.  </th>
                                   <th width="28%">Names of the Companies /bodies corporate/ firms/ association of individuals  </th>
                                   <th width="25%">Nature of interest or concern / Change in interest or concern  </th>
                                   <th width="20%"> Shareholding  </th>
                                   <th width="20%"> Date on which interest or concern arose / changed  </th>
                                </tr>
                             </thead>
                             <tbody class="p_list">
                                <tr>
                                   <td>1</td>
                                   <td>The Republic of accounting</td>
                                   <td>Finance</td>
                                   <td>80</td>
                                   <td>Test</td>
                                </tr>
                                <tr>
                                   <td>2</td>
                                   <td>The Republic of accounting</td>
                                   <td>Finance</td>
                                   <td>80</td>
                                   <td>Test</td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-signature">
                          <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left date_place">
                             <p><span><b>Place:</b></span> <span><input type="text" name="place" id="place" value="Bengaluru" class="form-control input-sm "></span></p>
                             <p><span><b>Date:</b></span> <span><input type="text" name="date" id="date" value="02-08-2021" class="form-control input-sm "></span></p>
                          </div>
                          <div class="col-sm-8 col-md-8 col-xs-12 p-l-r-0 f-left Signature_div">
                             <p class="text-right"><input type="text" name="place" id="place" class="form-control input-sm signatur_field"></p>
                             <p class="text-right" style="margin-bottom: 0px;"><b>Signature </b></p>
                             <p class="text-right" style="margin-bottom: 0px;"><b>MD/Director/Secretary/Whole time Director</b></p>
                          </div>
                       </div>
                    </form>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary gobtn">Download as PDF</button> </div>
            </div>
        </b-modal>
        <b-modal id="preview_model_dir2" centered  >
            <div class="required_documents">
                <div class="preview_model">
                    <form>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-heading">
                          <h4>Form DIR-2  </h4>
                          <p><b>Consent to act as a director of a company </b></p>
                          <p>[Pursuant to section 152(5) and rule 8 of Companies (Appointment and Qualification of Directors) Rules, 2014]  </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-to">
                          <p>To&nbsp;</p>
                          <table contenteditable="false" style="width: 35%;">
                             <tbody>
                                <tr>
                                   <td style="padding: 5px 10px 5px 0px;"> The Republic of accounting </td>
                                </tr>
                                <tr>
                                   <td style="padding: 5px 10px 5px 0px;"> 3rd Floor, Brigade Champak, Union Street, Infantry Road Bangalore – 560001 </td>
                                </tr>
                             </tbody>
                          </table>
                          <p style="padding-top: 10px;"><b>Subject:</b> Consent to act as a Director. </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content">
                          <p>I, <span role="textbox" contenteditable="false" class="input"><b>Deepak Kumar</b></span>, hereby give  my consent to act as director of <span role="textbox" contenteditable="false" class="input"><b>The Republic of accounting</b></span>, pursuant to sub-section (5) of section 152 of the Companies Act, 2013 and certify that I am not disqualified to become a director under the Companies Act, 2013. </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-table">
                          <table contenteditable="false" class="table table-border form-table">
                             <thead>
                                <tr>
                                   <th width="8%" style="width: 30px;">Sl No.  </th>
                                   <th width="58%">Particulars</th>
                                   <th width="35%">Details </th>
                                </tr>
                             </thead>
                             <tbody class="p_list">
                                <tr>
                                   <td>1</td>
                                   <td>Director Identification Number </td>
                                   <td>123CCLL69</td>
                                </tr>
                                <tr>
                                   <td>2</td>
                                   <td>Name (in full) </td>
                                   <td>Deepak Kumar</td>
                                </tr>
                                <tr>
                                   <td>3</td>
                                   <td>Father’s Name (in full) </td>
                                   <td>Sanjay Shiva</td>
                                </tr>
                                <tr>
                                   <td>4</td>
                                   <td>Address</td>
                                   <td>3rd Floor, Brigade Champak, Union Street, Infantry Road Bangalore – 560001</td>
                                </tr>
                                <tr>
                                   <td>5</td>
                                   <td>E-mail id </td>
                                   <td>Test@test.com</td>
                                </tr>
                                <tr>
                                   <td>6</td>
                                   <td>Mobile no  </td>
                                   <td>9874563210</td>
                                </tr>
                                <tr>
                                   <td>7</td>
                                   <td>Income-tax PAN </td>
                                   <td>EXDN98797P</td>
                                </tr>
                                <tr>
                                   <td>8</td>
                                   <td>Occupation </td>
                                   <td>Accounting Manager</td>
                                </tr>
                                <tr>
                                   <td>9</td>
                                   <td>Date of birth </td>
                                   <td>02-20-1996</td>
                                </tr>
                                <tr>
                                   <td>10</td>
                                   <td>Nationality</td>
                                   <td>India</td>
                                </tr>
                                <tr style="border-bottom: 0px !important;">
                                   <td>11</td>
                                   <td>No. of companies in which I am already a Director  </td>
                                   <td>1</td>
                                </tr>
                                <tr>
                                   <td></td>
                                   <td>Name of company in which I am Whole Time Director, Managing   Director,  CEO,  CFO, Secretary. </td>
                                   <td>The RoA</td>
                                </tr>
                                <tr>
                                   <td>12</td>
                                   <td>Particulars of membership No. and Certificate of practice no. if the applicant is a member of any professional Institute. Specifically, state NIL if none. </td>
                                   <td>APP12364PP</td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 declaration_para">
                          <p><b>Declaration</b></p>
                          <p>I declare that I have not been convicted of any offence in connection with the promotion, formation or management of any company or LLP and  have  not  been found guilty of any fraud or misfeasance or of any breach of duty to any company  under this Act  or any previous company law in the last five  years. I further declare   that if appointed my total Directorship in all the companies shall not exceed the prescribed number of companies in which a person can be appointed as a Director. </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-signature">
                          <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left date_place">
                             <p><span><b>Place:</b></span> <span><input type="text" name="place" id="placedir2" value="Bengaluru" class="form-control input-sm "></span></p>
                             <p><span><b>Date:</b></span> <span><input type="text" name="date" id="datedir2" value="02-08-2021" class="form-control input-sm "></span></p>
                          </div>
                          <div class="col-sm-8 col-md-8 col-xs-12 p-l-r-0 f-left Signature_div">
                             <p class="text-right"><b>Signature:</b> <span><input type="text" name="place" id="signagur_field" class="form-control input-sm signatur_field"></span></p>
                             <p class="text-right"><b>Designation:</b> <span><input type="text" name="place" id="desigination" value="Accounting Manager" class="form-control input-sm "></span></p>
                          </div>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 f-left form-content-enclosed">
                          <p>Enclosed: </p>
                          <p> Proof of identity. </p>
                          <p>    Proof of residence </p>
                       </div>
                    </form>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary gobtn">Download as PDF</button> </div>
            </div>
        </b-modal>
        <b-modal id="preview_model_form9Llp" centered  >
            <div class="required_documents">
                <div class="preview_model">
                    <form>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-heading">
                          <h4>FORM 9  </h4>
                          <p>[See rule 7 and 10(8)]</p>
                          <p><b>Consent to act as Designated Partner</b></p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-to">
                          <p>To&nbsp;</p>
                          <p><span role="textbox" contenteditable="false" class="input"><b>Deepak Kumar</b></span> <b>LLP</b></p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content f-left">
                          <p>I, <span role="textbox" contenteditable="false" class="input"><b>Deepak Kumar</b></span>, hereby give my consent to become a designated partner of <span role="textbox" contenteditable="false" class="input"><b>The Republic of accounting</b></span> <b>LLP</b>, under section 7(3) of Limited Liability Partnership Act 2008.</p>
                          <p>I have consented to become a designated partner of Limited Liability Partnership and also hereby undertake to contribute other property or other benefit or to perform service for Limited Liability Partnership as per the obligation described in the Limited Liability Partnership Agreement.</p>
                          <div class="col-sm-12 col-md-12 col-xs-12 p-l-r-0 f-left Particulars">
                             <p style="text-decoration: underline;"><b>Particulars</b></p>
                             <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left">
                                <p><b>Director Identification Number</b> <span style="float: right;">:</span></p>
                             </div>
                             <div class="col-sm-8 col-md-8 col-xs-12 f-left"><span>IDF123007</span></div>
                          </div>
                          <div class="col-sm-12 col-md-12 col-xs-12 p-l-r-0 f-left Particulars">
                             <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left">
                                <p><b>Name</b> <span style="float: right;">:</span></p>
                             </div>
                             <div class="col-sm-8 col-md-8 col-xs-12 f-left"><span>Dipin</span></div>
                          </div>
                          <div class="col-sm-12 col-md-12 col-xs-12 p-l-r-0 f-left Particulars">
                             <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left">
                                <p><b>Father's Name</b> <span style="float: right;">:</span></p>
                             </div>
                             <div class="col-sm-8 col-md-8 col-xs-12 f-left"><span>Noyal Nath</span></div>
                          </div>
                          <div class="col-sm-12 col-md-12 col-xs-12 p-l-r-0 f-left Particulars">
                             <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left">
                                <p><b>Present Residential Address</b> <span style="float: right;">:</span></p>
                             </div>
                             <div class="col-sm-8 col-md-8 col-xs-12 f-left"><span>3rd Floor, Brigade Champak, Union Street, Infantry Road Bangalore – 560001</span></div>
                          </div>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 declaration_para f-left">
                          <br> 
                          <p>I hereby state that I satisfy the condition and requirement for being eligible for designated partner and I have not been disqualified to act as a designated partner.</p>
                          <br>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-signature">
                          <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left date_place">
                             <p><span><b>Place:</b></span> <span><input type="text" name="place" id="place" value="Bengaluru" class="form-control input-sm "></span></p>
                             <p><span><b>Date:</b></span> <span><input type="text" name="date" id="date" value="02-08-2021" class="form-control input-sm "></span></p>
                          </div>
                          <div class="col-sm-8 col-md-8 col-xs-12 p-l-r-0 f-left Signature_div">
                             <p class="text-right"><input type="text" name="place" id="place" class="form-control input-sm signatur_field"></p>
                             <p class="text-right" style="margin-bottom: 0px;"><b>Signature </b></p>
                          </div>
                       </div>
                    </form>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary gobtn">Download as PDF</button> </div>
            </div>
        </b-modal>
        <b-modal id="preview_model_Subscribers" centered  >
            <div class="required_documents">
                <div class="preview_model">
                    <form>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-heading">
                          <h4>Subscriber’s Sheet including consent </h4>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content f-left">
                          <p>We, the several partners whose names are subscribed below, are desirous of being formed into a LLP for carrying on a lawful business with a view to earn profit and have entered or agreed to enter into a LLP agreement in writing.
                          </p>
                          <p>We respectively agree to contribute money or other property or other benefit or to perform services for the LLP in accordance with the LLP agreement, the particulars of which are stated against our respective names. </p>
                          <p>We hereby give our consent to become a partner/ designated partner/ nominee/ nominee &amp; designated partner of the LLP pursuant to section 7(4) / 25(3)(c) of the Limited Liability Partnership Act, 2008. </p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-table">
                          <table contenteditable="false" class="table table-border form-table">
                             <thead>
                                <tr>
                                   <th width="18%">Name of each partner/ designated partner/ nominee/ nominee &amp; designated partner  </th>
                                   <th width="18%">Name of each partner/ designated partner/ nominee/ nominee &amp; designated partner </th>
                                   <th width="18%">Signature of partner/ designated partner/ nominee/ nominee &amp; designated partner  </th>
                                   <th width="28%"> Name, address and profession (along with professional membership number) of witness  </th>
                                   <th width="18%"> Signature of witness  </th>
                                </tr>
                             </thead>
                             <tbody class="p_list">
                                <tr>
                                   <td>Devi Sujith</td>
                                   <td>Sooraj</td>
                                   <td>Test</td>
                                   <td rowspan="2">3rd Floor, Brigade Champak, Union Street, Infantry Road Bangalore – 560001</td>
                                   <td rowspan="2">Test</td>
                                </tr>
                                <tr>
                                   <td>Teena</td>
                                   <td>Sooraj</td>
                                   <td>Test</td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                    </form>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary gobtn">Download as PDF</button> </div>
            </div>
        </b-modal>
        <b-modal id="preview_modelDetails_companyLLP" centered  >
            <div class="required_documents">
                <div class="preview_model">
                    <form>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-heading ">
                          <h4>Details of company(s)/ LLP(s) in which partner/ designated partner/<br>nominee is a director/ partner </h4>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-to " style="padding-left: 13%; padding-bottom: 30px; padding-top: 20px;">
                          <p><b>1. <span role="textbox" contenteditable="false" class="input">Deepak Kumar</span> – Proposed Designated Partner </b></p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-table">
                          <table contenteditable="false" class="table table-border form-table" style="width: 80%; margin: 0px auto;">
                             <thead>
                                <tr>
                                   <th width="10%" style="width: 30px;">Sl No.  </th>
                                   <th width="45%">CIN/LLPIN </th>
                                   <th width="45%"> Name of the Company/LLP   </th>
                                </tr>
                             </thead>
                             <tbody class="p_list">
                                <tr>
                                   <td>1</td>
                                   <td>CINN69780</td>
                                   <td>The Republic of accounting</td>
                                </tr>
                                <tr>
                                   <td>2</td>
                                   <td>LLPCI562014</td>
                                   <td>The Republic of accounting</td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 " style="width: 80%; margin: 30px auto 0px;">
                          <p><b>I solemnly affirm that the above information is true and correct. </b></p>
                          <p><span role="textbox" contenteditable="false" class="input"><b>Deepak Kumar</b></span></p>
                       </div>
                       <div class="col-sm-12 col-md-12 col-xs-12 form-content-signature" style="width: 80%; margin: 0px auto; padding-top: 25px; float: none;">
                          <div class="col-sm-4 col-md-4 col-xs-12 p-l-r-0 f-left date_place">
                            <p><span><b>Place:</b></span> <span><input type="text" name="place" id="place" value="Bengaluru" class="form-control input-sm "></span></p>
                             <p><span><b>Date:</b></span> <span><input type="text" name="date" id="date" value="02-08-2021" class="form-control input-sm "></span></p>
                          </div>
                       </div>
                    </form>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary gobtn">Download as PDF</button> </div>
            </div>
        </b-modal>

        
        
	</div>
</template>
<script>
import file from '../services/fileupload'
import company_info from '../services/company_info';
export default {
    name:'business_info',
    props:['subscription'],
     watch:{
       subscription: function (){
          
       }
    },
    data() {
        return {
           doc_id:'',
           file_error:'',
           file_path:process.env.VUE_APP_URL,
        }
    },
    methods: {
        getFile(){
           this.file_error='';
            let formData = new FormData();
            for (var i = 0; i < this.$refs.doc.files.length; i++) {
                let file = this.$refs.doc.files[i];
                formData.append('files[' + i + ']', file);
               if(file.type!='application/pdf'){
                  return this.file_error='Invalid file format. Kindly select PDF files.';
               }
            }
            formData.append('doc_id', this.doc_id)
             file.uploadRequiredDoc(formData)
            .then(response =>{
                        if(response.data.status == 'success'){
                           window.location.reload();
                        }
                });
        },
         download_pdf(){
            company_info.postDownloadPdf({'doc_id':this.doc_id,'from':'billing'})
                    .then(res=>{
                        var response = res.data;
                         const url = this.file_path + response.path + "/" + response.file;
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = '_blank';
                            link.type = 'application/octet-stream';
                            link.download=response.file
                            // link.setAttribute("download", response.file); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // link.remove();
                    });
         },

    }
};

</script>
